import { IAutocompleteItem } from 'core/interface/autocompleteItem';
import { ITSkill, InitialValueBody } from 'core/interface/itSkill';
import { EscoSearchResult } from 'core/interface/escoSkill';
import { SaveComputerSkills } from '../../redux/slices/computer-skills';
import { SaveSkills } from '../../redux/slices/skills';
import { store } from '../../redux/store';
import ApiBase from 'services/base/apiBase';
import { prepareUpdatedData } from '../../helpers/stateChanges';

export class SkillService {
  private static apiBase = new ApiBase();

  public static async getITSkills(
    candidateId: number
  ): Promise<ITSkill[] | null> {
    const { dispatch } = store;
    try {
      const res = await this.apiBase.getAsync(
        `/candidates/${candidateId}/it-skills/`
      );
      dispatch(SaveSkills(res));
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  public static async getEscoSearch(params: {
    lang: string;
    type: string;
    q: string;
  }): Promise<EscoSearchResult[]> {
    try {
      const res = await this.apiBase.getAsync('/fixtures/esco/search/', params);
      return Array.isArray(res) ? res : [];
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  public static async getITSkillsList(
    search: string
  ): Promise<IAutocompleteItem[] | null> {
    const { dispatch } = store;
    try {
      const res = await this.apiBase.getAsync(
        `/fixtures/skills/?q=${search}&lang=en`
      );
      dispatch(SaveComputerSkills(res));
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  public static async addITSkill(
    candidate_id: number,
    body: InitialValueBody

  ): Promise<IAutocompleteItem[] | null> {
    const { dispatch } = store;
    try {
      const res = await this.apiBase.postAsync(
        `/candidates/${candidate_id}/it-skills/`,
        body
      );
      const updatedState = prepareUpdatedData(
        'create',
        'skills',
        res,
        'skills'
      );
      dispatch(SaveSkills(updatedState));
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  public static async updateITSkill(
    candidate_id: number,
    skill_id: number,
    body: InitialValueBody
  ): Promise<IAutocompleteItem[] | null> {
    const { dispatch } = store;
    try {
      const res = await this.apiBase.updateAsync(
        `/candidates/${candidate_id}/it-skills/${skill_id}/`,
        body
      );
      const updatedState = prepareUpdatedData(
        'update',
        'skills',
        res,
        'skills'
      );
      dispatch(SaveSkills(updatedState));
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  public static async removeITSkill(
    candidate_id: number,
    id: number
  ): Promise<boolean | null> {
    const { dispatch } = store;
    try {
      const res = await this.apiBase.deleteAsync(
        `/candidates/${candidate_id}/it-skills/${id}/`
      );
      const updatedState = prepareUpdatedData(
        'delete',
        'skills',
        {
          id
        },
        'skills'
      );
      dispatch(SaveSkills(updatedState));
      return res;
    } catch (error) {
      console.log(error);

      return null;
    }
  }

  public static async addGeneralSkill(
    candidateId: number,
    hardSkills: string[] = [],
    softSkills: string[] = []
  ): Promise<any> {
    try {
      const requestBody = {
        hard_skills: hardSkills,
        soft_skills: softSkills
      };

      const res = await this.apiBase.updateAsync(
        `/candidates/${candidateId}/`,
        requestBody
      );
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  }
}


